import styled from "@emotion/styled";
import Footer from "../../components/footer/Footer";
import TradeDataContent from "./App";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  overflow: clip;
`;

const Content = styled.div`
  flex: 1;
  width: 100%;
`;

const FullWidthPage = () => {
  return (
    <Container>
      <Content>
        <TradeDataContent />
      </Content>
      <Footer />
    </Container>
  );
};

export default FullWidthPage;
